export enum EventType {
  Performance = 'Performance',
  CustomEvent = 'CustomEvent',
  Qos = 'Qos',
  Warn = 'Warn',
  Error = 'Error'
}
